/**
 * Faixa fixa exibida enquanto um admin está "acessando como" um cliente
 * (sessão impersonada — o JWT carrega adminId). O botão volta para a conta do
 * admin via POST /spoofed-sessions/out, sem logout/login.
 *
 * Depois de trocar a sessão, recarrega a página em vez de navegar pelo router:
 * o Redux está cheio de dados do cliente (UCs, faturas, créditos, alertas) e
 * um reboot completo é a forma mais segura de não vazar nada para a sessão do
 * admin.
 */
import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import * as selectUser from 'store/user/user.selector';
import { spoofedOutUser } from 'store/user/user.action';

import { alert } from 'lib/alert';

import { Bar, BackButton } from './impersonation-banner.styles';

export const ImpersonationBanner = () => {
  const dispatch = useAppDispatch();
  const [isLeaving, setIsLeaving] = useState(false);

  const isImpersonating = useAppSelector(selectUser.isImpersonating);
  const currentUser = useAppSelector(selectUser.currentUser);
  const userStatus = useAppSelector(selectUser.status);
  const userAction = useAppSelector(selectUser.action);
  const userError = useAppSelector(selectUser.error);

  useEffect(() => {
    if (userAction !== 'spoofedOutUser') return;

    if (userStatus === 'successed') {
      window.location.assign('/admin/clientes');
    } else if (userStatus === 'failed') {
      setIsLeaving(false);
      alert.error(
        userError?.message ??
          'Não foi possível voltar para a sua conta. Faça login novamente.'
      );
    }
  }, [userAction, userStatus, userError]);

  if (!isImpersonating) return null;

  const handleBack = () => {
    setIsLeaving(true);
    dispatch(spoofedOutUser());
  };

  return (
    <Bar>
      <span>
        Você está acessando como{' '}
        <strong>{currentUser?.name ?? 'cliente'}</strong>
      </span>
      <BackButton type="button" onClick={handleBack} disabled={isLeaving}>
        {isLeaving ? 'Voltando...' : 'Voltar para minha conta admin'}
      </BackButton>
    </Bar>
  );
};
